import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=386ec1c5&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=js&"
export * from "./welcome.vue?vue&type=script&lang=js&"
import style0 from "./welcome.vue?vue&type=style&index=0&id=386ec1c5&prod&scoped=true&lang=css&"
import style1 from "./welcome.vue?vue&type=style&index=1&id=386ec1c5&prod&scoped=true&lang=less&"
import style2 from "./welcome.vue?vue&type=style&index=2&id=386ec1c5&prod&lang=less&scoped=true&"
import style3 from "./welcome.vue?vue&type=style&index=3&id=386ec1c5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ec1c5",
  null
  
)

export default component.exports